import { Component, OnInit } from '@angular/core';
import { LocationService } from 'app/masters/location-master/location.service';
import { paytypeModal } from 'app/masters/models/service-master.model';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-pay-type-master',
  templateUrl: './pay-type-master.component.html',
  styleUrls: ['./pay-type-master.component.scss']
})
export class PayTypeMasterComponent implements OnInit {
  destroypayType$: Subject<boolean> = new Subject<boolean>();
  dataSource = new MatTableDataSource<any>();
  paytypeData: paytypeModal = {};
  displayedColumns: string[] = ['paytypeName', 'isActive'];
  searchValue: string;
  holdpayData: any;
  constructor(public LocationService: LocationService) { }

  ngOnInit(): void {
    this.getpaytypeMaster(0)
    this.dataSource.filterPredicate = this.createFilter();
  }
  openpaytypeModal() {
    document.getElementById("paytypeModal").style.display = 'block';
    this.getpaytypeMaster(0)
  }

  closepaytypeModal() {
    document.getElementById("paytypeModal").style.display = 'none';
    this.searchValue = ''
    this.dataSource.filter = ''
  }
  savepayMaster() {
    if (!this.paytypeData.pK_PayTypeId) {
      const existingPay = this.holdpayData.find(
        (pay) => pay.payType.toLowerCase() === this.paytypeData.payType?.toLowerCase());

      if (existingPay) {
        this.LocationService.openSnackBar('Already exists in the list', 'OK');
        this.clearForm();
        return;
      }
      const payload = {
        "InsertPayTypeMasterDto": {
          "PK_PayTypeId": this.paytypeData.pK_PayTypeId ? this.paytypeData.pK_PayTypeId : 0,
          "PayType": this.paytypeData.payType,
          "IsActive": this.paytypeData.isActive ? this.paytypeData.isActive : false,
          "PayTypeGroup": null,
          "IsEdit": false
        }
      }

      this.LocationService.InsertPayTypeMaster(payload).pipe(takeUntil(this.destroypayType$)).subscribe(
        (response: any) => {
          this.LocationService.openSnackBar('Record saved successfully', 'OK');
          this.clearForm();
          this.searchValue = ''
          this.getpaytypeMaster(0)
        },
        err => {
          if (err.status == 403) {
            this.LocationService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.LocationService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.LocationService.openSnackBar("API Failed", "OK");
          }
          this.searchValue = ''
        }
      );
    } else {
      const payload = {
        "InsertPayTypeMasterDto": {
          "PK_PayTypeId": this.paytypeData.pK_PayTypeId ? this.paytypeData.pK_PayTypeId : 0,
          "PayType": this.paytypeData.payType,
          "IsActive": this.paytypeData.isActive ? this.paytypeData.isActive : false,
          "PayTypeGroup": null,
          "IsEdit": true
        }
      }

      this.LocationService.InsertPayTypeMaster(payload).pipe(takeUntil(this.destroypayType$)).subscribe(
        (response: any) => {
          this.LocationService.openSnackBar('Record updated successfully', 'OK');
          this.clearForm();
          this.searchValue = ''
          this.getpaytypeMaster(0)
        },
        err => {
          if (err.status == 403) {
            this.LocationService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.LocationService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.LocationService.openSnackBar("API Failed", "OK");
          }
          this.searchValue = ''
        }
      );
    }
  }

  clearForm() {
    this.paytypeData = {
      pK_PayTypeId: 0,
      payType: '',
      isActive: false,
      payTypeGroup: null
    }
  }
  getpaytypeMaster(id) {
    this.LocationService.GetPayTypeMaster(id).pipe(takeUntil(this.destroypayType$)).subscribe((x: any) => {
      this.paytypeData = x;
      this.dataSource.data = x;
      this.holdpayData = x
    }, err => {
      if (err.status == 403) {
        this.LocationService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.LocationService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.LocationService.openSnackBar("API Failed", "OK");
      }
    });
  }

  applypaytypeFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  createFilter(): (data: any, filter: string) => boolean {
    return (data, filter): boolean => {
      const transformedFilter = filter.trim().toLowerCase();
      return (
        data.payType?.toLowerCase().includes(transformedFilter) ||
        (data.isActive ? 'active' : 'inactive').includes(transformedFilter)
      );
    };
  }

  onRowDoubleClick(row) {
    this.paytypeData.payType = row.payType;
    this.paytypeData.isActive = row.isActive;
    this.paytypeData.pK_PayTypeId = row.pK_PayTypeId;
    this.closepaytypeModal()
  }


  ngOnDestroy() {
    this.destroypayType$.next(true);
    this.destroypayType$.unsubscribe();
    this.paytypeData = null;
    this.searchValue = null;
    this.holdpayData = null;
  }
}
